export enum INSTRUCTION_STATUS {
  PROCESSING = 1, // code is being generated
  READY = 2, // code generated, ready to be used in a workflow
  FAILED = 3, // failed to generate code
}

export type InstructionStatus = INSTRUCTION_STATUS
